/*
 * Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
export default (function (strings) {
  return [{
    label: strings['global.cancel'],
    type: 'secondary',
    confirms: false
  }, {
    label: strings['global.continue'],
    type: 'primary',
    confirms: true
  }];
});